export const logError = (message: string, context?: Record<string, unknown>): void => {
  console.error(`[ERROR] ${message}`, context)
}

export const logInfo = (message: string, context?: Record<string, unknown>): void => {
  console.info(`[INFO] ${message}`, context)
}

export const logWarning = (message: string, context?: Record<string, unknown>): void => {
  console.warn(`[WARN] ${message}`, context)
}

export const withSentryErrorBoundary = (component: React.ComponentType<unknown>) => component

export const initSentry = (): void => {
  console.info('[Sentry Stub] Sentry initialization skipped - package removed')
}
